import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const { t } = useTranslation();

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year);
  }, []);

  return (
    <div className="footer-wrap mt-16">
      <div className="max-w-[1120px] mx-auto px-6 pt-14 pb-7">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr] gap-12 pb-9 border-b border-white/10">
          <div>
            <div className="lingoFooterMark mb-3">
              <span>Lingo Club</span>
            </div>
            <p className="text-sm leading-7 mb-5 opacity-80">
              {t("redesign.footer_tagline")}
            </p>
            <div className="inline-flex items-center gap-2 bg-[rgba(108,99,255,.2)] text-[#a78bfa] text-xs font-semibold px-3 py-1 rounded-full">
              {t("redesign.footer_nonprofit")}
            </div>
          </div>
          <div>
            <div className="text-white font-bold text-sm mb-4">{t("footer.company")}</div>
            <ul className="flex flex-col gap-2.5 list-none">
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/">{t("footer.home")}</Link></li>
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/become-a-leader">{t("header.become_a_leader")}</Link></li>
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/become-a-learner">{t("header.become_a_learner")}</Link></li>
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/schedule-meeting">{t("header.schedule_meeting")}</Link></li>
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/our-team">{t("footer.our_team")}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-white font-bold text-sm mb-4">{t("footer.legal")}</div>
            <ul className="flex flex-col gap-2.5 list-none">
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/terms-conditions">{t("footer.terms_conditions")}</Link></li>
              <li><Link className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" to="/privacy-policy">{t("footer.privacy")}</Link></li>
              <li><a className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" href="mailto:support@lingoclub.org">{t("redesign.footer_contact")}</a></li>
              <li><a className="text-sm opacity-80 hover:text-white hover:opacity-100 transition-colors" href="https://donate.stripe.com/dR6cPS8O8ailbxC3cc">{t("redesign.footer_donate")}</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-5 flex flex-wrap justify-between text-xs opacity-70">
          <span>&copy; {currentYear} <strong className="text-white">LingoClub</strong>{t("redesign.footer_copyright_suffix")}</span>
          <span>{t("redesign.footer_made_with")}</span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
